import React, { useEffect, useState } from 'react'
import DashboardMenu from '../dashboard/DashboardMenu'
import { AssignedHandeledByLiveClassService, GetLiveClassService, GetLiveClassUsersDetailService } from '../../services/LiveClassServices';
// import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button'
// import { DatePicker, Modal } from 'antd';
// import { useNavigate } from 'react-router-dom';
// import {FiChevronRight,FiChevronLeft} from 'react-icons/fi';
// import { IconButton } from '@material-ui/core';
// import { AiOutlineEdit,AiOutlineDelete,AiOutlineFileExcel } from 'react-icons/ai';
// import { FaUsersBetweenLines } from "react-icons/fa6";
import { CgRadioCheck,CgRadioChecked } from "react-icons/cg";
import moment from 'moment';
import { useLocation, useNavigate } from 'react-router-dom';
import { ButtonFilledAutoWidth } from '../../components/button';
import { AiOutlineEdit } from 'react-icons/ai';


function LiveClassListAttendees() {

  const [data, setdata] = useState({pagination:{total:0}});
  const [page,setpage] = useState(1)
  const [search,setsearch] = useState({text:'',from_date:'',from_date1:'',to_date:'',to_date1:''})
  const [allData,setallData] = useState([])

  const [step,setstep] = useState('All Users')
  const statusArr = ['All Users','Joined Users','Not Joined Users']

  const navigator = useNavigate()

  const stateData = useLocation()
  const state = stateData?.state

  // console.log("state",state)

  useEffect(()=>{
    getData()
  },[page])

  async function getData() {
    const response = await GetLiveClassUsersDetailService(state?._id)
    if(response?.data?.datas?.length > 0){
      let d = response?.data?.datas[0]
      console.log("response?.data",response?.data)
      console.log("d here",d)
      if(step === 'All Users'){
          setallData([...d?.attended,...d?.not_attended])
      }else if(step === 'Joined Users'){
          setallData([...d?.attended])
      }else if(step === 'Not Joined Users'){
          setallData([...d?.not_attended])
      }
      setdata(response?.data?.datas[0])
    }else{

    }
  }

  async function applyFilter(){
    setsearch({...search,activate:true})
    setpage(1)
    const response =  await GetLiveClassService(1,search?.text,search?.from_date1,search?.to_date1)
    setdata(response?.data)
  }

  async function resetfilter(){
    setsearch({text:'',from_date:'',to_date:'',from_date1:'',to_date1:'',activate:false})
    setpage(1)
    const response =  await GetLiveClassService(1,'','','')
    setdata(response?.data)
  }

  async function checkAssignedData() {
    const response = await AssignedHandeledByLiveClassService()
    // console.log("response",response?.data)
  }

  function setdatafunc(s){
    if(s === 'All Users'){
      setallData([...data?.attended,...data?.not_attended])
    }else if(s === 'Joined Users'){
      setallData([...data?.attended])
    }else if(s === 'Not Joined Users'){
      setallData([...data?.not_attended])
    }
  }

  return (
    <div className='md:h-screen md:min-h-screen md:max-h-screen md:overflow-hidden'>
      <div className='md:flex'>
        <DashboardMenu />
        <div className='md:w-[100%] px-4 py-4 md:w-[86%] md:h-screen md:min-h-screen md:max-h-screen md:overflow-y-scroll relative'>
            <div className='md:flex w-full mt-2 border-b justify-between pb-3'>
                <div className='flex items-center justify-between'>
                  <h6 className='font-[800] text-[13px]'>Total Live Class Attendees ({allData?.length})</h6>
                  <div className='flex items-center md:hidden text-[12px]'>

                    {/* <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit } - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>

                    <IconButton onClick={()=>{page > 1 ? setpage(page-1) : console.log('')}}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`}  size={16} /></IconButton>
                    <IconButton onClick={()=>{ page < data?.pagination?.totalPages  ? setpage(page+1) : console.log('')}}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`}  size={16} /></IconButton> */}
                  </div> 
                </div> 

                <div className='flex flex-wrap items-center text-[12px]'>

                    <div className='hidden md:flex items-center'>

                    {/* <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit } - {data?.pagination?.limit} of {data?.pagination?.total}  </h6> */}

                    {/* <div>
                    <IconButton onClick={()=>{page > 1 ? setpage(page-1) : console.log('')}}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`}  size={16} /></IconButton>
                    <IconButton onClick={()=>{ page < data?.pagination?.totalPages  ? setpage(page+1) : console.log('')}}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`}  size={16} /></IconButton>
                    </div> */}
                    </div>  
                    {/* <DatePicker  size='small' style={{fontSize:'11px'}} ampm={false} placeholder='From Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2'  value={search?.from_date} onChange={(v,v1) => {console.log('v na',new Date(v).toLocaleDateString());setsearch({...search,from_date:v,from_date1:v1})}} /> 

                    <DatePicker size='small' style={{fontSize:'11px'}} ampm={false} placeholder='To Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2'  value={search?.to_date} onChange={(v,v1) => {console.log('v na',new Date(v).toLocaleDateString());setsearch({...search,to_date:v,to_date1:v1})}} /> 
                    
                    <div className='mr-2 mt-1 md:mt-0'>
                    <input  id="search_text" placeholder='Search text' type='text' value={search.text} onChange={(e)=>setsearch({...search,text:e.target.value})} className='border py-[3px] focus:ring-0 focus:outline-0 text-[14px]  w-[100px] px-1 rounded-md border-slate-300' />
                    </div>  
                    <div className='mr-2 mt-1 md:mt-0'>
                    <ButtonOutlinedAutoWidth btnName="Apply Filter" onClick={()=>applyFilter()} /> 
                    </div>
                    <div className='mr-2 mt-1 md:mt-0'>
                    <ButtonOutlinedAutoWidth btnName="Reset Filter" onClick={()=>resetfilter()} /> 
                    </div> */}

                    {/* <ButtonFilledAutoWidth btnName="Assigned Data"  onClick={()=>checkAssignedData()} /> */}
                   
                </div>
            </div>

            <div className='flex items-center border-b overflow-x-auto flex-nowrap'>
                {statusArr?.map((s)=>(<h6 onClick={()=>{setstep(s);setdatafunc(s)}} className={`font-[600] ${step === s && 'bg-slate-800 text-white'} text-center cursor-pointer py-1 w-[100px] text-[11px]`}>{s}</h6>))}
            </div>

<div className='md:h-[90vh] mb-[50px] md:overflow-hidden'>
                            
                {allData?.length === 0 &&
                <div className='grid place-items-center mt-20  items-center justify-center'>
                    <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' /> 
                    <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
                    <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data based on your current stage please add the data to see list here.</h6>
                </div>}

                <div className='w-[100%] overflow-hidden'>
                    {allData?.length > 0 &&
                     <>
                     {/* Desktop / tablet table */}
                     <div className='hidden md:block md:max-h-[85vh] mt-4 border-t md:overflow-auto border-l border-r'>
                          <div className='sticky top-0 z-50 flex w-full  bg-white py-[-5px] border-b border-slate-200 relative'>
                                <h6 className='top-0 bg-white z-50 text-[12px] min-w-[50px] w-[50px]  px-2 py-1 font-[600] text-slate-800 border-r flex items-center justify-center'>Sl No</h6>
                                <h6 className='sticky top-0 z-50  text-[12px]  min-w-[180px] w-[180px]  px-2 py-1 font-[600] text-slate-800 border-r'>Client Name</h6>
                                <h6 className='sticky top-0 z-50  text-[12px]  min-w-[160px] w-[160px]  px-2 py-1 font-[600] text-slate-800 border-r'>Mobile </h6>
                                <h6 className='sticky top-0 z-50  text-[12px]  min-w-[160px] w-[160px]  px-2 py-1 font-[600] text-slate-800 border-r'>Email</h6>
                                <h6 className='sticky top-0 z-50  text-[12px] min-w-[180px] w-[180px]  px-2 py-1 font-[600] text-slate-800 border-r'>Remarks</h6>
                                <h6 className='sticky top-0 z-50  text-[12px] min-w-[180px] w-[180px]  px-2 py-1 font-[600] text-slate-800 border-r'>Intested  / Subscribed</h6>
                                <h6 className='sticky top-0 z-50  text-[12px] min-w-[120px] w-[120px]  px-2 py-1 font-[600] text-slate-800 border-r'>Created At</h6>
                                <h6 className='sticky top-0 z-50  text-[12px] min-w-[80px] w-[80px]  px-2 py-1 font-[600] text-slate-800 '>Actions</h6>
                            </div>
                          {allData?.map((d,i)=>(
                          <div key={d?._id || i} className='flex w-full text-[11px]  bg-white py-[-5px] border-b border-slate-200 relative'>
                            <h6 className='bg-white text-[12px] min-w-[50px] w-[50px]  px-2 py-1 font-[500] border-r flex items-start justify-center'>{(page > 1 ? i + 1 + (data?.pagination?.limit * (page - 1)) : i + 1)}</h6>
                            <h6 className=' text-[11px] break-word min-w-[180px] w-[180px] px-2 py-1 border-r'>
                                <span className='font-bold'>{d?.name}</span>
                                <br></br>
                                <span>Class : {d?.campaign_info?.enter_class}</span>
                                <h6 className='text-[11px]  font-[600] capitalize'>Source System :  {d?.source} </h6>

                                <h6 className='mt-1'>Handled By :</h6>
                                {d?.handled_by?.map((h)=>(<span className='font-bold text-blue-500'>{h?.name},</span>))}
                                {d?.session_status && <h6 className='text-[13px] w-max bg-green-200 text-green-900 p-1 text-[8px] font-[600]'>Session Active</h6>}


                        <div className='flex flex-wrap'>
                        {d?.app_installed && <h6 className='bg-green-200 p-[2px] m-[2px] text-[10px] font-[600] w-max rounded'>{'App Installed'}</h6>}
                        {d?.subscribed && <h6 className='bg-yellow-200 p-[2px] m-[2px] text-[10px] font-[600] w-max rounded'>{'Subscribed'}</h6>}
                        {d?.temp_subscribed && <h6 className='bg-violet-200 p-[2px] m-[2px] text-[10px] font-[600] w-max rounded'>{'Temp Subscribed'}</h6>}
                        {d?.demo_call_completed && <h6 className='bg-red-200 p-[2px] m-[2px] text-[10px] font-[600] w-max rounded'>{'Demo Watched'}</h6>}
                        </div>
                            </h6>
                            <h6 className=' text-[12px] break-word min-w-[160px] w-[160px] px-2 py-1 font-[500] border-r'>
                                <span className='font-bold'>{d?.mobile}</span><br></br>
                                {d?.mobile?.length > 10 && <span className='bg-green-100 p-[4px] text-green-800'>True</span>}
                            </h6>
                            <h6 className=' text-[12px] break-all min-w-[160px] w-[160px]  px-2 py-1 font-[500] border-r'>
                            {d?.email}
                            </h6>
                            <h6 className=' text-[11px] break-word min-w-[180px] w-[180px]  px-2 py-1  border-r'>
                                {d?.remarks}
                            </h6>
                            <h6 className='flex   break-word  min-w-[180px] w-[180px]  px-2 py-1 font-[500] border-r'>{!d?.interested ? <CgRadioCheck size={15} className='text-slate-300' /> : <CgRadioChecked size={15} className='text-yellow-500' />} <span className='mx-2 text-slate-300'>/</span>  {!d?.subscribed ? <CgRadioCheck size={15} className='text-slate-300' /> : <CgRadioChecked size={15} className='text-yellow-500' />}  </h6>
                            <h6 className='  break-word min-w-[120px] w-[120px]  px-2 py-1 font-[500] border-r'>{moment(d?.createdAt)?.format('LLL')}</h6>
                            <h6 className='flex items-start  min-w-[80px] w-[80px]  px-2 py-1 font-[500] '>
                                <AiOutlineEdit onClick={() => navigator('/clients/list/edit', { state: d })} className='mr-2' />
                                {/* <MdOutlineCallToAction onClick={() => navigator('/clients/list/call_to_customer', { state: d })} className='mr-2' />
                                {roles.includes('admin') && <AiOutlineDelete onClick={() => { setselecteddata(d); setmodal(true) }} />} */}
                            </h6>
                            </div>))}
                     </div>

                     {/* Mobile card list */}
                     <div className='md:hidden mt-3 space-y-2'>
                        {allData?.map((d,i)=>(
                          <div key={d?._id || i} className='border rounded-md p-3 bg-white'>
                            <div className='flex items-start justify-between'>
                              <div>
                                <h6 className='text-[13px] font-[700]'>{d?.name}</h6>
                                <h6 className='text-[11px] text-slate-600'>{d?.mobile}</h6>
                              </div>
                              <span className='p-2 -mr-1.5 cursor-pointer'><AiOutlineEdit size={17} onClick={() => navigator('/clients/list/edit', { state: d })} /></span>
                            </div>

                            <h6 className='text-[11px] mt-2'>Class : {d?.campaign_info?.enter_class || '-'}</h6>
                            <h6 className='text-[11px] font-[600] capitalize'>Source System : {d?.source}</h6>
                            {d?.email && <h6 className='text-[11px] break-all mt-1'>{d?.email}</h6>}

                            <h6 className='text-[11px] mt-1'>Handled By : {d?.handled_by?.map((h)=>h?.name).join(', ') || '-'}</h6>
                            {d?.session_status && <h6 className='text-[10px] w-max bg-green-200 text-green-900 px-1.5 py-0.5 rounded mt-1 font-[600]'>Session Active</h6>}

                            <div className='flex flex-wrap mt-1.5'>
                              {d?.app_installed && <h6 className='bg-green-200 px-1.5 py-1 m-[2px] text-[10px] font-[600] rounded'>App Installed</h6>}
                              {d?.subscribed && <h6 className='bg-yellow-200 px-1.5 py-1 m-[2px] text-[10px] font-[600] rounded'>Subscribed</h6>}
                              {d?.temp_subscribed && <h6 className='bg-violet-200 px-1.5 py-1 m-[2px] text-[10px] font-[600] rounded'>Temp Subscribed</h6>}
                              {d?.demo_call_completed && <h6 className='bg-red-200 px-1.5 py-1 m-[2px] text-[10px] font-[600] rounded'>Demo Watched</h6>}
                            </div>

                            {d?.remarks && <h6 className='text-[11px] mt-2'><span className='font-[600]'>Remarks:</span> {d?.remarks}</h6>}

                            <div className='flex items-center mt-2 text-[11px]'>
                              <span className='font-[600] mr-1'>Interested</span>{!d?.interested ? <CgRadioCheck size={15} className='text-slate-300' /> : <CgRadioChecked size={15} className='text-yellow-500' />}
                              <span className='mx-2 text-slate-300'>/</span>
                              <span className='font-[600] mr-1'>Subscribed</span>{!d?.subscribed ? <CgRadioCheck size={15} className='text-slate-300' /> : <CgRadioChecked size={15} className='text-yellow-500' />}
                            </div>

                            <h6 className='text-[10px] text-slate-400 mt-2'>Created {moment(d?.createdAt)?.format('LLL')}</h6>
                          </div>
                        ))}
                     </div>
                     </>}
                </div>
            </div>  

      </div>

      </div>
    </div>    
  )
}

export default LiveClassListAttendees